module.exports = __webpack_public_path__ + "img/credential7.41e79ef9.png";